/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ConstructorViewInfoStatus {
    NO_ERROR = 'NoError',
    NOT_AVAILABLE = 'NotAvailable',
    ACCESS_DENIED = 'AccessDenied',
    LIMIT_EXCEED = 'LimitExceed',
    LIMITED_ACCOUNT = 'LimitedAccount',
    ACCOUNT_FROZEN = 'AccountFrozen',
    NO_CONSTRUCTOR = 'NoConstructor',
}
